import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=3f7733ed&lang=pug"
import script from "./payment.vue?vue&type=script&lang=coffee"
export * from "./payment.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports